import React, { useContext } from "react";
import { Grid, TextField, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import PageConfig, { PageContext } from "../../configs";

const EmailInputField = ({
  value,
  onChange,
  disabled,
  fieldError,
  showChangeBtn = false,
}) => {
  const { t } = useTranslation();
  const { setFormUIState } = useContext(PageContext);

  const onClickShowChangeBtn = () => {
    const { FORM_UI_STATE } = PageConfig;
    setFormUIState(FORM_UI_STATE.ADD_NEW_EMAIL);
  };

  return (
    <Grid container direction="column" className="row-gap-4">
      <Grid
        container
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
        className="column-gap-8"
      >
        <Typography className="typography-form-element-label py-4 text-semi-bold">
          {t("settingPage.yourEmailAddress")}
        </Typography>
        {showChangeBtn && (
          <Typography
            className="typography-form-element-label email-change-text text-semi-bold"
            onClick={onClickShowChangeBtn}
          >
            ({t("common.edit")})
          </Typography>
        )}
      </Grid>
      <TextField
        value={value}
        onChange={onChange}
        type="email"
        variant="outlined"
        className="email-input"
        disabled={disabled}
      />
      <Typography className="form-error-text typography-caption-1">
        {fieldError ?? ""}
      </Typography>
    </Grid>
  );
};

export default EmailInputField;
